import React from "react";
import { useNavigate } from "react-router";
import { ButtonMain } from "components";
import { IsImageLoaded } from "utils";
import { Images } from "assets";

export const Home = () => {
  const navigate = useNavigate();
  const imageLoaded = IsImageLoaded(Images.homeBanner);

  const goToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="home-page-wrapper">
      <div className="home-page-box">
        <div className="home-page-banner">
          <img src={Images.homeBannerSmall} alt="Home Image" />

          <img
            src={Images.homeBanner}
            alt="Home Image"
            style={{
              opacity: imageLoaded ? 1 : 0,
              transition: "opacity 0.5s ease-in-out",
              visibility: imageLoaded ? "visible" : "hidden",
            }}
          />
        </div>
        <div className="home-main-content">
          <div className="home-main-logo">
            <img src={Images.logoImg} alt="log" />
          </div>

          <h2 className="home-title">
            Smarter Ambulance Management, Faster Patient Care.
          </h2>

          <p className="home-description">
            CareTech streamlines ambulance dispatch, tracking, and patient care
            coordination—ensuring faster response times and seamless operations.
          </p>

          <ButtonMain
            text="Sign In"
            buttonMainStyles={{ width: 285 }}
            onClick={goToLogin}
          />
          <a href="/privacy" target={'_blank'} style={{marginTop: 12}} className="privacy-link">
             Privacy
          </a>
        </div>
      </div>
    </div>
  );
};
